<app-manage-template *ngIf="teamDetails!= null && userDatas!=null" [title]="'Edit Workspace'"
    (updateParent)="updateTeam($event)" (updateMembers)="updateTeamMembers($event)" [KEY]="'TEAM_WORKSPACES'"
    [FIELDS]="fields" [COLUMNFIELDS]="columns" [parentData]="teamDetails"
    [userData]="(userDatas | async)" [onSearch]="onSearch" [showCrown]="true" [ownerView]="true"
    [onFilter]="onFilter" [this]="this" [onScroll]="onScroll" [holder]="'Search by members or email'">

    <div Owner>
       <ng-select #ownerSelect [items]="employeesList | async"
        [clearable]="true"
        (change)="onChange()"
        (clear)="onClear()"
        (close)="onClose()"
        (scrollToEnd)="onScrollEmployee()"
        [virtualScroll]="true"
        [loading]="loading"
        loadingText="Loading..."
        bindLabel="fullName"
        bindValue="userId"
        placeholder="Select employee"
        [(ngModel)]="selectedEmployee"
        [notFoundText]="notFound"
        class="frayed"
        [typeahead]="searchSubject"
        [closeOnSelect]="false"
        [notFoundText]="notFound"
      >
      <ng-template ng-label-tmp let-item="item">
        <div [title]="item.fullName" class="owner-label">{{ item.fullName }}</div>
      </ng-template>
      <ng-template ng-notfound-tmp>
    <div class="gs-no-results">{{ notFound }}</div>
  </ng-template>
      </ng-select>

    </div>


  </app-manage-template>
  <app-common-skeleton *ngIf="teamDetails== null || userDatas==null" [NameOftheScreen]="'jobselectedscreen'"></app-common-skeleton>
 